<div class="app-address-form">
  <!-- Row 1: CEP | Rua/Avenida -->
  <div class="app-address-form__row">
    <div class="app-address-form__field">
      @if (isFieldVisible('cep')) {
      <aprova-input
        #inputCep
        dataTestid="addressFormInputCep"
        [control]="form.controls.cep"
        class="w-full"
        label="CEP"
        [placeholder]="iaMode() ? '00000-000' : ''"
        tabindex="1"
        inputMode="numeric"
        mask="00000-000"
        [required]="true"
        [disabled]="isFieldBlocked('cep')"
        [errorMessages]="{
          required: 'Por favor preencha o campo CEP.'
        }"
      >
        @if (loading()) {
          <aprova-loading-spinner append size="xs" color="#06929F" />
        }
      </aprova-input>
      @if (cepNotice() === 'not_found') {
        <p class="app-address-form__cep-notice app-address-form__cep-notice--error">
          CEP não encontrado. Verifique se está correto.
        </p>
      } @else if (cepNotice() === 'unavailable') {
        <p class="app-address-form__cep-notice app-address-form__cep-notice--warning">
          Não conseguimos validar o CEP no momento. Preencha o endereço manualmente.
        </p>
      }
      @if (iaMode() && !isFieldBlocked('cep')) {
      <button type="button" class="app-address-form__link" data-testid="addressFormButtonWithoutCep" (click)="useAddressWithoutCep()">
        Não sei meu CEP
      </button>
      }
      } @else {
      <button type="button" class="app-address-form__link" data-testid="addressFormButtonWithCep" (click)="useCep()">
        Tenho o CEP
      </button>
      }
    </div>

    @if (cepSummary(); as summary) {
    <div class="app-address-form__cep-summary">
      <svg class="app-address-form__cep-summary-icon" viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <path d="M12 21s-7-6.2-7-11.5a7 7 0 0 1 14 0C19 14.8 12 21 12 21z" />
        <circle cx="12" cy="9.5" r="2.5" />
      </svg>
      <div class="app-address-form__cep-summary-text" data-testid="addressFormMessageCepAddress">
        @if (summary.street) {
        <p class="app-address-form__cep-summary-street">{{ summary.street }}</p>
        }
        <p class="app-address-form__cep-summary-place">{{ summary.place }}</p>
      </div>
      @if (canEditCepAddress()) {
      <button type="button" class="app-address-form__link" data-testid="addressFormButtonEditAddress" (click)="editCepAddress()">
        Alterar
      </button>
      }
    </div>
    }

    @if (isFieldVisible('rua')) {
    <div class="app-address-form__field">
      <aprova-input
        #inputStreet
        dataTestid="addressFormInputStreet"
        [control]="form.controls.rua"
        class="w-full"
        label="Rua/Avenida"
        tabindex="2"
        [required]="true"
        maxlength="255"
      />
    </div>
    }
  </div>

  <!-- Row 2: Número (with Sem número checkbox) | Complemento -->
  <div class="app-address-form__row" [class.app-address-form__row--pair]="iaMode()">
    <div class="app-address-form__field app-address-form__field--with-checkbox">
      <aprova-input
        #inputNumber
        inputType="number"
        inputMode="numeric"
        class="w-full"
        [control]="form.controls.numero"
        label="Número"
        [placeholder]="iaMode() ? '000' : ''"
        tabindex="3"
        maxlength="144"
        [required]="!noNumberAddress()"
        [disabled]="isFieldBlocked('numero') || noNumberAddress()"
      />
      <!-- Sem número checkbox inside the field area -->
      <div class="app-address-form__no-number">
        <aprova-checkbox
          [checked]="noNumberAddress()"
          (onChange)="toogleNoNumberAddress()"
        >
          <span class="app-address-form__no-number-label">Sem número</span>
        </aprova-checkbox>
      </div>
    </div>

    <div class="app-address-form__field">
      <aprova-input
        [control]="form.controls.complemento"
        class="w-full"
        [label]="iaMode() ? 'Complemento' : 'Complemento (opcional)'"
        [placeholder]="iaMode() ? 'Opcional' : ''"
        tabindex="4"
        [required]="false"
        [disabled]="isFieldBlocked('complemento')"
      />
    </div>
  </div>

  <!-- Row 3: Bairro | Cidade -->
  @if (isFieldVisible('bairro') || isFieldVisible('cidade')) {
  <div class="app-address-form__row">
    @if (isFieldVisible('bairro')) {
    <div class="app-address-form__field">
      <aprova-input
        #inputNeighborhood
        dataTestid="addressFormInputNeighborhood"
        [control]="form.controls.bairro"
        class="w-full"
        label="Bairro"
        tabindex="5"
        [required]="true"
        [disabled]="isFieldBlocked('bairro')"
        [errorMessages]="{
          required: 'Preencha corretamente seu bairro.'
        }"
      />
    </div>
    }

    @if (isFieldVisible('cidade')) {
    <div class="app-address-form__field">
      <aprova-input
        dataTestid="addressFormInputCity"
        [control]="form.controls.cidade"
        class="w-full"
        label="Cidade"
        tabindex="6"
        [required]="true"
        [disabled]="isFieldBlocked('cidade')"
        [errorMessages]="{
          required: 'Preencha corretamente sua cidade.'
        }"
      />
    </div>
    }
  </div>
  }

  <!-- Row 4: Estado (alone) -->
  @if (isFieldVisible('estado')) {
  <div class="app-address-form__row app-address-form__row--half">
    <div class="app-address-form__field">
      <aprova-input
        dataTestid="addressFormInputState"
        [control]="form.controls.estado"
        class="w-full"
        label="Estado"
        tabindex="7"
        [required]="true"
        [disabled]="isFieldBlocked('estado')"
        [errorMessages]="{
          required: 'Preencha corretamente seu estado.'
        }"
      />
    </div>
  </div>
  }

  @if (isLastStep) {
  <div class="app-address-form__terms">
    <aprova-checkbox
      [control]="form.controls.termos"
      class="font-normal text-sm leading-4 text-gray-500"
      color="#06929F"
    >
      Li e aceito os
      <a
        href="https://assets-publicos.s3.amazonaws.com/Termos+de+Uso.pdf"
        target="_blank"
        class="app-address-form__terms-link"
      >
        termos de uso
      </a>
    </aprova-checkbox>
  </div>

  @if(!hideRecaptcha){
  <aprova-recaptcha [recaptchaFormControl]="form.controls.recaptchaReactive" />
  } }
</div>
